import HttpService from "@/utils/httpData"

export const getBookByCode = code => {
    let apiEndpoint = `Book/GetBookByCode?bookCode=${code}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getRoleUser = () => {
    let apiEndpoint = `Book/GetRoleUser`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getAllBookGroup = () => {
    let apiEndpoint = `Book/catBookGroupGetList`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getBooksForActive = payload => {
    let apiEndpoint = `Book/GetBookByCode`;
    return HttpService.post(apiEndpoint, payload).then(res => {
        if (res && res.data && !res.data.errors) {
            return res.data.data ? res.data.data : null;
        } else if (res && res.data && res.data.errors) {
            return { fail: true, errors: res.data.errors }
        }
        return false;
    }).catch(e => { return false });
}

export const activeBook = (activeCode, bookId) => {
    let apiEndpoint = `Book/ActiveBookById`;
    return HttpService.post(apiEndpoint, { bookId, activeCode }).then(res => {
        if (res && res.data && res.data.errors) {
            return false
        } else {
            return res && res.data;
        }
    }).catch(e => { return false });
}

export const deActiveBook = (esStampId, bookId, isForce = 0) => {
    let apiEndpoint = `Book/DeactiveBook`;
    return HttpService.post(apiEndpoint, { bookId, esStampId, isForce }).then(res => {
        return res && res.data && res.data.data ? res.data.data : null;
    }).catch(e => { return false });
}

export const apiGetBookCodeActived = (esStampId) => {
    let apiEndpoint = `Book/GetActiveCode?esStampId=${esStampId}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res && res.data && res.data.data ? res.data.data : null;
    }).catch(e => { return false });
}

export const apiCheckRedirect = (bookId) => {
    let apiEndpoint = `Book/CheckRedirect/${bookId}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}